module.exports = __webpack_public_path__ + "img/awards_image_18.46196ac7.jpg";